import createLucideIcon from '../createLucideIcon';

const AlignCenter = createLucideIcon('AlignCenter', [
  ['line', { x1: '21', x2: '3', y1: '6', y2: '6', key: '1fp77t' }],
  ['line', { x1: '17', x2: '7', y1: '12', y2: '12', key: 'rsh8ii' }],
  ['line', { x1: '19', x2: '5', y1: '18', y2: '18', key: '1t0tuv' }],
]);

export default AlignCenter;
